import { Component, app } from "modular-openscriptjs";
import { uniqueId, either, closeModal } from "../../helpers";

const h = app("h");

// Check DOM structure inside _modal.scss
export default class Modal extends Component {
    /**
     *
     * @param {{id:string, title:string, center:boolean, bottom:boolean, fullscreen:boolean, footer:string}} config
     * @param  {...any} args
     * @returns
     */
    render(config, ...args) {
        const id = `${config?.id ?? uniqueId()}`;
        this.wabId = id;
        const title = config?.title ?? "Modal Title";
        const center = config?.center ?? true;
        const bottom = config?.bottom ?? false;
        const fullscreen = config?.fullscreen ?? false;
        const footer = config?.footer ?? null;

        return h.$(
            h.div(
                {
                    data_wab_id: id,
                    class: [
                        "wab-modal-backdrop",
                        center ? "wab-modal-center" : "",
                        bottom ? "wab-modal-bottom" : "",
                        fullscreen ? "wab-modal-fullscreen" : "",
                    ]
                        .join(" ")
                        .trim(),
                },
                h.div(
                    { class: "wab-modal" },
                    h.div(
                        { class: "wab-modal-header" },
                        h.h2({ class: "wab-modal-title" }, title),
                        h.button({
                            class: "wab-modal-close",
                            onclick: h.func("closeModal", id),
                            "aria-label": "Close modal",
                        }),
                    ),
                    h.div({ class: "wab-modal-body" }, ...args),
                    either(
                        footer,
                        h.div({ class: "wab-modal-footer" }, footer),
                    ),
                ),
            ),
        );
    }

    cleanUp() {
        super.cleanUp();
        if (this.wabId) {
            closeModal(this.wabId);
        }
    }
}
